import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { g as getLocale, l as transDialog } from './utils2.js';
import { d as defineCustomElement$1 } from './mapy-review-button2.js';

const mapyReviewQuestionCss = ".mapy-review-question{font-family:Arial;display:flex;flex-direction:column;gap:24px}.default-btn{cursor:pointer;border-radius:4px;border:1px solid #E5E5E5;padding:6px 12px;background:#fff;font-size:14px;font-style:normal;font-weight:400;line-height:24px;height:36px;box-sizing:border-box}.default-btn:hover{border-color:#6E6E6E}h3{color:#000;text-align:center;font-size:18px;font-style:normal;font-weight:700;line-height:140%;margin:0}.buttons{display:flex;flex-direction:column;gap:8px}.position{margin:0;text-align:center;color:#6E6E6E;font-size:12px;font-style:normal;font-weight:400;line-height:16px;}";
const MapyReviewQuestionStyle0 = mapyReviewQuestionCss;

var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m")
        throw new TypeError("Private method is not writable");
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MapyReviewQuestion_lang;
const MapyReviewQuestion = /*@__PURE__*/ proxyCustomElement(class MapyReviewQuestion extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.answer = createEvent(this, "answer", 1);
        _MapyReviewQuestion_lang.set(this, "");
        this.onYesClick = () => {
            this.answer.emit("yes");
        };
        this.dontKnowClick = () => {
            this.answer.emit("dont_know");
        };
        this.noClick = () => {
            this.answer.emit("no");
        };
        this.service = "mapy";
        this.question = "";
        this.questPos = 1;
        this.questCount = 0;
    }
    componentWillLoad() {
        __classPrivateFieldSet(this, _MapyReviewQuestion_lang, getLocale(this.hostElement), "f");
    }
    render() {
        return (h(Host, { key: '7d38f0e427e5331aa062796fbe7bd59693f6d25a' }, h("div", { key: '5fd0260478a1727031a596034d519e2770fec383', class: "mapy-review-question" }, h("h3", { key: '53198c74dbc57b43805ce41579577ef56a03bf56' }, this.question), h("div", { key: '02bcc85801cfda9fd5f64c4336c4559c73045f6e', class: "buttons" }, this.questPos === 1 && h("mapy-review-button", { onClick: this.onYesClick, service: this.service }, transDialog(__classPrivateFieldGet(this, _MapyReviewQuestion_lang, "f"), "responseYes")), this.questPos !== 1 && h("button", { class: "default-btn", type: "button", onClick: this.onYesClick }, transDialog(__classPrivateFieldGet(this, _MapyReviewQuestion_lang, "f"), "responseYes")), h("button", { key: '2a15dfeb4b7aa89565dfc41848a341d79634cd0d', class: "default-btn", type: "button", onClick: this.dontKnowClick }, transDialog(__classPrivateFieldGet(this, _MapyReviewQuestion_lang, "f"), "responseDontKnow")), h("button", { key: '6353540e128d019408d22989caefd436f055209c', class: "default-btn", type: "button", onClick: this.noClick }, transDialog(__classPrivateFieldGet(this, _MapyReviewQuestion_lang, "f"), "responseNo"))), h("p", { key: '393b1fd5b3d3afa31ddbc04f424126832968e11e', class: "position" }, transDialog(__classPrivateFieldGet(this, _MapyReviewQuestion_lang, "f"), "questionsPosition", {
            current: this.questPos,
            total: this.questCount,
        })))));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewQuestionStyle0; }
}, [1, "mapy-review-question", {
        "service": [513],
        "question": [513],
        "questPos": [514, "quest-pos"],
        "questCount": [514, "quest-count"]
    }]);
_MapyReviewQuestion_lang = new WeakMap();
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-question", "mapy-review-button"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-question":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewQuestion);
            }
            break;
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewQuestion as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-question2.js.map